import {Event} from 'main.core';
import {SkuProperty} from './skuproperty.js';

export class SkuPropertiesManager extends Event.EventEmitter {
    static instances = {}

    constructor(params) {
        super();
        this.setEventNamespace('BX.Asteq.Catalog.SkuPropertiesManager');

        this.el = params.el;
        this.props = [];
        this.initProps(params.skuProps);

        this.constructor.addInstance(this);
    }

    getComponentId() {
        if (!this.el) {
            return null;
        }

        return this.el.id;
    }

    initProps(propsData) {
        for (let prop of propsData) {
            const property = new SkuProperty({
                data: prop,
                manager: this,
            });

            property.subscribe('change', this.onPropertyChange.bind(this));

            this.props.push(property);
        }
    }

    getSelectedValues() {
        const result = [];
        for (let prop of this.props) {
            result.push({
                propId: prop.data.id,
                propCode: prop.data.code,
                valueId: prop.getSelectedId(),
            });
        }
        return result;
    }

    onPropertyChange(e) {
        const selectedValues = this.getSelectedValues();


        this.emit('valueChange', {
            selectedValues: selectedValues,
            change: {
                property: e.target,
                ...e.getData(),
            },
        });
    }

    onUpdatePropertiesValue(e) {
        const eventData = e.getData();

        const displayPropsValues = eventData.displayPropsValues;
        if (displayPropsValues) {
            for (let prop of this.props) {
                prop.setDisplayValues(displayPropsValues[prop.getId()]);
            }
        }

        const selectedPropsValues = eventData.selectedValues;
        if (selectedPropsValues) {
            for (let prop of this.props) {
                prop.selectValueById(selectedPropsValues[prop.getId()]);
            }
        }
    }

    static addInstance(instance) {
        const instanceKey = instance.getComponentId();
        if (this.instances[instanceKey]) {
            console.error(`Instance with ${instanceKey} already exists`);
            return;
        }

        this.instances[instanceKey] = instance;
    }

    static getInstance(instanceKey) {
        return this.instances[instanceKey];
    }

    static removeInstance(instance) {
        const instanceKey = instance.getComponentId();
        if (!this.instances[instanceKey]) {
            return;
        }

        delete this.instances[instanceKey];
    }
}